import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from './../components/api'
import moment from 'moment'
//import { useTabelaGestao } from '../context/GestaoPendenciasContext'
import { Link } from 'react-router-dom'

import { useEnunciadoContext } from '../context/enunciadoContext'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../components/StatusValidacaoSecao'


const Comunicacao = (props) => {

    //var { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()


    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id


    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()


    const [questao15, setQuestao15] = useState()
    const [questao16, setQuestao16] = useState()
    const [questao17, setQuestao17] = useState()
    const [questao18, setQuestao18] = useState()
    const [questao19, setQuestao19] = useState()
    
    const [totalPendencias, setTotalPendencias] = useState(0)

    //var [adesao_institucional_id, setAdesaoInstitucionalId] = useState(sessionStorage.getItem('adesao_institucional_id'))
    var [compras_id, setCompras_id] = useState()


    var [comunicaInicPartesIntere, setComunicaInicPartesIntere] = useState()
    var [ceProg, setCeProg] = useState()
    var [ceCapac, setCeCapac] = useState()
    var [ceComunica, setCeComunica] = useState()
    var [ceEventos, setCeEventos] = useState()
    var [ceEstimuloBP, setCeEstimuloBP] = useState()
    var [ceNaoHaInic, setCeNaoHaInic] = useState()
    var [ceOutras, setCeOutras] = useState()
    var [ceOutrasDescri, setCeOutrasDescri] = useState()
    var [possuiProcFormais, setPossuiProcFormais] = useState()
    var [csReunioes, setCsReunioes] = useState()
    var [csEventos, setCsEventos] = useState()
    var [csManual, setCsManual] = useState()
    var [csSolicit, setCsSolicit] = useState()
    var [csSistema, setCsSistema] = useState()
    var [csOutra, setCsOutra] = useState()
    var [csOutraDescri, setCsOutraDescri] = useState()
    var [integraCriterios, setIntegraCriterios] = useState()


    function salvaComunicacao() {

        var dataPost = {

            comunicaInicPartesIntere: comunicaInicPartesIntere,
            ceProg: ceProg,
            ceCapac: ceCapac,
            ceComunica: ceComunica,
            ceEventos: ceEventos,
            ceEstimuloBP: ceEstimuloBP,
            ceNaoHaInic: ceNaoHaInic,
            ceOutras: ceOutras,
            ceOutrasDescri: ceOutrasDescri,
            possuiProcFormais: possuiProcFormais,
            csReunioes: csReunioes,
            csEventos: csEventos,
            csManual: csManual,
            csSolicit: csSolicit,
            csSistema: csSistema,
            csOutra: csOutra,
            csOutraDescri: csOutraDescri,
            integraCriterios: integraCriterios,


        }


        console.log(dataPost)

        //console.log(compras_id, '!?')

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (compras_id) {


                    api.put(`comprasComunicacao/${compras_id}`, dataPost).then((result) => {

                        console.log(result.data)
                        window.toastr.success('Registro salvo com sucesso!')
                        //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                    }).catch((err) => {

                        console.log(err.response)

                    })

                } else {


                    api.post(`comprasComunicacao/${adesao_institucional_id}/${ano}`, dataPost).then((result) => {

                        console.log(result.data)

                        setCompras_id(result.data[0].compras_id)
                        window.toastr.success('Registro salvo com sucesso!')
                        //setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                    }).catch((err) => {

                        console.log(err.response)

                    })



                }

                },

		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });
    

    }


    async function carregaComprasComunicacao() {

        setCompras_id()
        setComunicaInicPartesIntere()
        setCeProg()
        setCeCapac()
        setCeComunica()
        setCeEventos()
        setCeEstimuloBP()
        setCeNaoHaInic()
        setCeOutras()
        setCeOutrasDescri()
        setPossuiProcFormais()
        setCsReunioes()
        setCsEventos()
        setCsManual()
        setCsSolicit()
        setCsSistema()
        setCsOutra()
        setCsOutraDescri()
        setIntegraCriterios()


        if (ano && adesao_institucional_id) {


            await api.get(`comprasComunicacao/${adesao_institucional_id}/${ano}`).then((result) => {


                console.log(result.data)

                if (result.data[0]) {

                    var data = result.data[0]

                    setCompras_id(data.compras_id)

                    setComunicaInicPartesIntere(data.comunicaInicPartesIntere)
                    setCeProg(data.ceProg)
                    setCeCapac(data.ceCapac)
                    setCeComunica(data.ceComunica)
                    setCeEventos(data.ceEventos)
                    setCeEstimuloBP(data.ceEstimuloBP)
                    setCeNaoHaInic(data.ceNaoHaInic)
                    setCeOutras(data.ceOutras)
                    setCeOutrasDescri(data.ceOutrasDescri)
                    setPossuiProcFormais(data.possuiProcFormais)
                    setCsReunioes(data.csReunioes)
                    setCsEventos(data.csEventos)
                    setCsManual(data.csManual)
                    setCsSolicit(data.csSolicit)
                    setCsSistema(data.csSistema)
                    setCsOutra(data.csOutra)
                    setCsOutraDescri(data.csOutraDescri)
                    setIntegraCriterios(data.integraCriterios)

                   
                    
                }


            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    useEffect(() => {
        

        carregaComprasComunicacao()

        setQuestao15()
        setQuestao16()
        setQuestao17()
        setQuestao18()
        setQuestao19()
        
        
        

    }, [ano, adesao_institucional_id])







    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao15()
        setQuestao16()
        setQuestao17()
        setQuestao18()
        setQuestao19()
        
        
        

        if (compras_id) {

            var dataPost = {

                formulario_id: compras_id,
                desafio: 'Compras',

            }
            console.log('aqui')

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case '15. A sua organização comunica suas iniciativas em Compras Sustentáveis às partes interessadas?':

                                totalErros = totalErros + 1
                                setQuestao15('red')
    
                            break

                            case '16. A comunicação e engajamento de funcionários é realizada pela organização através das seguintes atividades: (Assinale todas as opções aplicáveis)':

                                totalErros = totalErros + 1
                                setQuestao16('red')

                            break

                            case '17. A organização possui processos formais para receber sugestões ou reclamações das partes interessadas com relação às iniciativas de Compras Sustentáveis?':

                                totalErros = totalErros + 1
                                setQuestao17('red')

                            break

                            case '18. Em relação aos seus fornecedores, como a organização comunica suas demandas e critérios de sustentabilidade? (Assinale todas as opções aplicáveis)':

                                totalErros = totalErros + 1
                                setQuestao18('red')

                            break

                            case '19. A sua organização integra critérios de sustentabilidade em suas práticas de gestão de desempenho e reconhecimento de fornecedores?':

                                totalErros = totalErros + 1
                                setQuestao19('red')

                            break



                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    useEffect(() => {

        verificaValidacoes()

    }, [compras_id, verificaDesafio])




    return (

        <div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao15 }} onClick={() => {setEnunciado('15. A sua organização comunica suas iniciativas em Compras Sustentáveis às partes interessadas?');setSecaoEnunciado('Seção III');window.$('#modalValidacao').modal('show')}}>
                            15. A sua organização comunica suas iniciativas em Compras Sustentáveis às partes interessadas?
                            </Link>
                            
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comunicaInicPartesIntere" onChange={() => setComunicaInicPartesIntere('S')} checked={ comunicaInicPartesIntere == 'S' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Sim, a organização comunica suas iniciativas em Compras Sustentáveis &agrave;s partes interessadas
                            </td>
                            
                        </tr>         
                        <tr  style={{display: 'none'}}>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comunicaInicPartesIntere" onChange={() => setComunicaInicPartesIntere('A')} checked={ comunicaInicPartesIntere == 'A' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Sim, a organização comunica suas iniciativas em Compras Sustentáveis a algumas partes interessadas
                            </td>
                            
                        </tr>      
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="comunicaInicPartesIntere" onChange={() => setComunicaInicPartesIntere('N')} checked={ comunicaInicPartesIntere == 'N' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Não, a organização ainda não comunica suas iniciativas em Compras Sustentáveis às partes interessadas
                            </td>
                            
                        </tr>      
                       

                    </tbody>
                </Table>

            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao16 }} onClick={() => {setEnunciado('16. A comunicação e engajamento de funcionários é realizada pela organização através das seguintes atividades: (Assinale todas as opções aplicáveis)');setSecaoEnunciado('Seção III');window.$('#modalValidacao').modal('show')}}>
                            16. A comunicação e engajamento de funcionários é realizada pela organização através das seguintes atividades: (Assinale todas as opções aplicáveis)
                            </Link>                           
                            
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="ceProg" value={ceProg} onChange={event => setCeProg(event.target.checked)} checked={ ceProg ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Programas de capacitação específicos sobre Compras Sustentáveis
                            </td>
                            
                        </tr>         
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="ceCapac" value={ceCapac} onChange={event => setCeCapac(event.target.checked)} checked={ ceCapac ? 1 : 0}  disabled />
                                </center>
                            </td>
                            <td>
                            Capacitações sobre Compras Sustentáveis inseridas em programas de capacitação para Sustentabilidade
                            </td>
                            
                        </tr>      
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="ceComunica" value={ceComunica} onChange={event => setCeComunica(event.target.checked)} checked={ ceComunica ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Comunicação sobre práticas e avanços em Compras Sustentáveis
                            </td>
                            
                        </tr>      
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="ceEventos" value={ceEventos} onChange={event => setCeEventos(event.target.checked)} checked={ ceEventos ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Eventos temáticos
                            </td>
                            
                        </tr>    

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="ceEstimuloBP" value={ceEstimuloBP} onChange={event => setCeEstimuloBP(event.target.checked)} checked={ceEstimuloBP ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Estímulo e reconhecimento de boas práticas 
                            </td>
                            
                        </tr>    
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="ceNaoHaInic" value={ceNaoHaInic} onChange={event => setCeNaoHaInic(event.target.checked)} checked={ceNaoHaInic ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Não há iniciativas para desenvolver a cultura para Compras Sustentáveis
                            </td>
                            
                        </tr>   
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="ceOutras" value={ceOutras} onChange={event => setCeOutras(event.target.checked)} checked={ceOutras ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Outras atividades
                            </td>
                            
                        </tr>   
                        <tr>
                            <td colspan="2">
                                <input type="text" class="form_text" id="ceOutrasDescri" placeholder="Informe..." maxlength="255" value={ceOutrasDescri} onChange={event => setCeOutrasDescri(event.target.value)} disabled />
                            </td>
                        </tr>
                       
                       

                    </tbody>
                </Table>

            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao17 }} onClick={() => {setEnunciado('17. A organização possui processos formais para receber sugestões ou reclamações das partes interessadas com relação às iniciativas de Compras Sustentáveis?');setSecaoEnunciado('Seção III');window.$('#modalValidacao').modal('show')}}>
                            17. A organização possui processos formais para receber sugestões ou reclamações das partes interessadas com relação às iniciativas de Compras Sustentáveis?
                            </Link>
                            
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="possuiProcFormais" value={possuiProcFormais} onChange={() => setPossuiProcFormais('S')} checked={possuiProcFormais == 'S' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Sim, existem canais específicos para coletar sugestões e reclamações referentes às Compras Sustentáveis
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="possuiProcFormais" value={possuiProcFormais} onChange={() => setPossuiProcFormais('A')} checked={possuiProcFormais == 'A' ? 1 : 0} disabled/>
                                </center>
                            </td>
                            <td>
                            A organização utiliza os canais já instituídos para coletar sugestões e reclamações e orienta seus analistas para identificar questões relacionadas às Compras Sustentáveis
                            </td>
                            
                        </tr>  
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="possuiProcFormais" value={possuiProcFormais} onChange={() => setPossuiProcFormais('N')} checked={possuiProcFormais == 'N' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            A organização não tem formalizado o processo de coleta de sugestões e reclamações referentes às iniciativas de Compras Sustentáveis
			
                            </td>
                            
                        </tr>  

                    </tbody>
                </Table>

            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao18 }} onClick={() => {setEnunciado('18. Em relação aos seus fornecedores, como a organização comunica suas demandas e critérios de sustentabilidade? (Assinale todas as opções aplicáveis)');setSecaoEnunciado('Seção III');window.$('#modalValidacao').modal('show')}}>
                            18. Em relação aos seus fornecedores, como a organização comunica suas demandas e critérios de sustentabilidade? (Assinale todas as opções aplicáveis)
                            </Link>
                            
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="csReunioes" value={csReunioes} onChange={event => setCsReunioes(event.target.checked)} checked={ csReunioes ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Em reuniões individuais com fornecedores
                            </td>
                            
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="csEventos" value={csEventos} onChange={event => setCsEventos(event.target.checked)} checked={ csEventos ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Em eventos com grupos de fornecedores
                            </td>
                            
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="csManual" value={csManual} onChange={event => setCsManual(event.target.checked)} checked={ csManual ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            No Manual de Fornecedores (ou documento similar)
                            </td>
                            
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="csSolicit" value={csSolicit} onChange={event => setCsSolicit(event.target.checked)} checked={ csSolicit ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Na solicitação de proposta de compras / licitação
                            </td>
                            
                        </tr>

                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="csSistema" value={csSistema} onChange={event => setCsSistema(event.target.checked)} checked={ csSistema ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Por meio do sistema de homologação e qualificação de fornecedores
                            </td>
                            
                        </tr>

                      
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="checkbox" name="csOutra" value={csOutra} onChange={event => setCsOutra(event.target.checked)} checked={ csOutra ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Outra
                            </td>
                            
                        </tr>
                        <tr style={{ display: csOutra ? 'table-row' : 'none' }}>
                            <td colspan="2">
                                <input type="text" class="form_text" id="csOutraDescri" placeholder="Informe..." maxlength="255" value={csOutraDescri} onChange={event => setCsOutraDescri(event.target.value)} disabled />
                            </td>
                        </tr>


                    </tbody>
                </Table>
            </div>

            <div className="col-md-12">


                <Table striped bordered hover>
                    
                    <tbody>
                        <tr>
                            <td style={{backgroundColor: '#e6f7ec'}} colspan="2">
                            <Link style={{ color: questao19 }} onClick={() => {setEnunciado('19. A sua organização integra critérios de sustentabilidade em suas práticas de gestão de desempenho e reconhecimento de fornecedores?');setSecaoEnunciado('Seção III');window.$('#modalValidacao').modal('show')}}>
                            19. A sua organização integra critérios de sustentabilidade  em suas práticas de gestão de desempenho e reconhecimento de fornecedores?
                            </Link>
                            
                            </td>
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="integraCriterios" value={integraCriterios} onChange={() => setIntegraCriterios('S')} checked={integraCriterios == 'S' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Sim, há um programa formalizado de reconhecimento de fornecedores por suas práticas e esforços em sustentabilidade
                            </td>
                            
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="integraCriterios" value={integraCriterios} onChange={() => setIntegraCriterios('P')} checked={integraCriterios == 'P' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Sim, o reconhecimento de fornecedores ocorre pontualmente conforme identificadas boas práticas e esforços em sustentabilidade
                            </td>
                            
                        </tr>
                        <tr>
                            <td style={{width: '120px'}}>
                                <center>
                                <input type="radio" name="integraCriterios" value={integraCriterios} onChange={() => setIntegraCriterios('N')} checked={integraCriterios == 'N' ? 1 : 0} disabled />
                                </center>
                            </td>
                            <td>
                            Não, prática ainda não adotada
                            </td>
                            
                        </tr>

                    </tbody>

                </Table>

            </div>


            <StatusValidacaoSecao desafio="Compras" totalPendencias={totalPendencias} secaoCampo="secaoIII" nomeDesafio="Desafio Compras" formulario_id={compras_id} secao="Seçao III - Comunicação" ano={ano} />


        </div>
    )

}

export default Comunicacao